<template>
  <div class="wc-register__container mx-auto my-4">
    <WCSpinner v-if="loading" position="center" size="xl" />

    <template v-else>
      <WCAlert class="alert-danger mx-0 w-100 px-3" v-if="error && errorAlert">
        <div class="d-flex align-items-center flex-column flex-sm-row">
          <div>
            <div class="text-danger font-size-lg font-weight-bold">
              {{ errorAlert.heading }}
            </div>
            {{ errorAlert.content }}
            <span class="font-weight-bold">{{ $t('resetPasswordAlert') }}</span>
          </div>
          <router-link
            :to="{ name: 'ForgotPassword' }"
            tag="button"
            class="btn btn-danger w-100 ml-sm-2 mt-3 mt-sm-0"
            >{{ $t('setPassword') }}</router-link
          >
        </div>
      </WCAlert>
      <WCRegisterForm @submit="signup" />
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import WCAlert from '@/modules/alerts/components/WCAlert/WCAlert.vue';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import TrackableEventConstants from '@/constants/TrackableEventConstants';
import AnalyticsService from '@/services/analytics.service';
import WCSpinner from '../../../../components/WCSpinner/WCSpinner.vue';
import WCRegisterForm from '../../components/WCRegisterForm/WCRegisterForm.vue';

export default {
  name: 'Register',
  components: {
    WCSpinner,
    WCRegisterForm,
    WCAlert,
  },
  data() {
    return {
      loading: false,
      error: null,
    };
  },
  methods: {
    async signup(payload) {
      this.loading = true;
      let requestPayload = payload;
      if (this.isCustomerModeScan) {
        requestPayload = { ...payload, scan: true };
      }
      try {
        const response = await axios.post('api/auth/signup', requestPayload);

        const account = response.data.data;
        if (response.data.code === 0 && account) {
          AnalyticsService.track(TrackableEventConstants.CustomerRegistration, {
            account,
          });
          this.$router.push({
            name: 'CheckEmail',
            query: { account, email: payload.email },
          });
        }
      } catch (error) {
        const response = error.response;
        this.error = response?.data?.errors;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : 'Failed to register';
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: 'Error',
            message,
          },
          timeout: 7000,
        });
        this.loading = false;
      }
    },
  },
  computed: {
    errorAlert() {
      let errorObj = null;
      if (this.error?.email && this.error?.email[0] === 'used') {
        errorObj = {
          heading: this.$t('emailInUseHeading'),
          content: this.$t('emailInUseContent'),
        };
      } else if (this.error?.phone && this.error?.phone[0] === 'used') {
        errorObj = {
          heading: this.$t('phoneNumberInUseHeading'),
          content: this.$t('phoneNumberInUseContent'),
        };
      } else if (this.error?.message) {
        errorObj = {
          heading: this.error.message,
        };
      }

      return errorObj;
    },
    // Check if the user is logging in via scan mode
    isCustomerModeScan() {
      return this.$route.query.scan === 'true';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-register__container {
  width: 100%;
}

@include media-breakpoint-up(md) {
  .wc-register__container {
    width: 35rem;
  }
}
</style>
